// extracted by mini-css-extract-plugin
export default {"need_hand":"NeedHand_need_hand__o9m7P","need_help_input":"NeedHand_need_help_input__UkJUH","need_hand_child":"NeedHand_need_hand_child__+SL5U"};